import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { missingTranslations } from '../request/missingTranslations';
export var initTranslations = function (_a) {
    var accessToken = _a.accessToken, useTranslationDebugger = _a.useTranslationDebugger, translationsLoaded = _a.translationsLoaded, currentLanguage = _a.currentLanguage, application = _a.application;
    i18n
        // pass the i18n instance to react-i18next.
        .use(initReactI18next)
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init({
        lng: 'en_US',
        fallbackLng: 'en_US',
        // https://www.i18next.com/principles/fallback#key-not-found
        nsSeparator: false,
        keySeparator: false,
        debug: false,
        saveMissing: true,
        react: {
            useSuspense: false,
        },
        missingKeyHandler: function (lngs, ns, key, fallbackValue) {
            if (useTranslationDebugger) {
                window.missingTranslations.set(key, fallbackValue);
            }
            if (translationsLoaded && currentLanguage && accessToken) {
                missingTranslations({
                    application: application,
                    language: String(currentLanguage),
                    key: key,
                    access_token: accessToken,
                });
            }
        },
    });
};
//# sourceMappingURL=initTranslations.js.map